'use strict';

var Sugar = require('sugar-core');

require('../enumerable/build/buildFromIndexMethodsCall');

module.exports = Sugar.Array.forEachFromIndex;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/array/forEachFromIndex.js
// module id = 378
// module chunks = 0